"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableViewWithSearchFiltersAndToggle = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var LayoutTableWithSearchAndToggle_1 = require("./LayoutTableWithSearchAndToggle");
var utils_1 = require("../utils");
var p = utils_1.createPrefixer("wh-Layouts-TableViewWithSearchFiltersAndToggle-");
var classes = {
    top: p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["top"], ["top"]))),
    bottom: p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["bottom"], ["bottom"]))),
    topLeft: p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["top-left"], ["top-left"]))),
    topRight: p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["top-right"], ["top-right"]))),
};
var Wrapper = styled_components_1.default(antd_1.Row)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  & {\n    .", " {\n      padding: 0 1rem;\n    }\n  }\n"], ["\n  & {\n    .", " {\n      padding: 0 1rem;\n    }\n  }\n"])), classes.top);
var TableViewWithSearchFiltersAndToggle = function (_a) {
    var left = _a.left, right = _a.right, _b = _a.wrapperProps, wrapperProps = _b === void 0 ? {} : _b, children = _a.children, rest = __rest(_a, ["left", "right", "wrapperProps", "children"]);
    return (react_1.default.createElement(Wrapper, __assign({ gutter: [0, 16] }, wrapperProps),
        react_1.default.createElement(antd_1.Col, { span: 24 },
            react_1.default.createElement("div", { className: classes.top },
                react_1.default.createElement(antd_1.Row, { wrap: false, justify: "space-between" },
                    react_1.default.createElement(antd_1.Col, { className: classes.topLeft }, left),
                    react_1.default.createElement(antd_1.Col, { className: classes.topRight }, right)))),
        react_1.default.createElement(antd_1.Col, { xs: 24, className: classes.bottom },
            react_1.default.createElement(LayoutTableWithSearchAndToggle_1.LayoutTableWithSearchAndToggle, __assign({}, rest))),
        children));
};
exports.TableViewWithSearchFiltersAndToggle = TableViewWithSearchFiltersAndToggle;
TableViewWithSearchFiltersAndToggle.classes = classes;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
